import { render, staticRenderFns } from "./AppLayoutSupport.vue?vue&type=template&id=81206886"
import script from "./AppLayoutSupport.vue?vue&type=script&lang=js"
export * from "./AppLayoutSupport.vue?vue&type=script&lang=js"
import style0 from "./AppLayoutSupport.vue?vue&type=style&index=0&id=81206886&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports